<template>
  <div class="components__rec-date-field">
    <div
      v-if="description.readonly"
    >{{ description.label }}: {{ formatISODate(description.ivalue) }}</div>
    <SimpleDatepicker
      v-else
      v-bind:name="description.name"
      v-model="description.ivalue"
      small
    >{{ description.label }}</SimpleDatepicker>
  </div>
</template>

<script lang="ts" setup>
 import parseISO from "date-fns/parseISO";
 import format from "date-fns/format";

 import { recProps } from "../../mixins/rec-component";
 
 import SimpleDatepicker from "vue/applications/frontend/components/simple-datepicker.vue"
 
 defineProps({...recProps()});

 const formatISODate = (strDate: string) => {
   return format(parseISO(strDate), "dd.MM.yyyy");
 }
</script>
